(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["3dids-customer-orders"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-order-toggle]');
    if (!button) return;
    const id = button.getAttribute('data-order-toggle');
    const detail = document.querySelector('tr[data-order="' + id + '"]');
    if (!detail) return;
    const opening = detail.hasAttribute('hidden');
    detail.toggleAttribute('hidden', !opening);
    const parent = document.querySelector('tr[data-order-parent="' + id + '"]');
    if (parent && window.matchMedia('(max-width: 749px)').matches) {
      parent.classList.toggle('is-open', opening);
    }
  });
  (function () {
    const apply = () => {
      const orders = document.getElementById('order-history');
      const profile = document.getElementById('profile-account');
      if (!orders && !profile) return;
      const hash = window.location.hash;
      const designMode = window.Shopify && window.Shopify.designMode;
      const showOrders = hash.indexOf('order-history') > -1;
      const showProfile = hash.indexOf('account-profile') > -1 && !showOrders;
      if (orders) orders.hidden = !(showOrders || designMode);
      if (profile) profile.hidden = !(showProfile || designMode);
      const breadcrumbOrders = document.getElementById('breadcrumb-order-history');
      const breadcrumbProfile = document.getElementById('breadcrumb-account-profile');
      if (breadcrumbOrders) breadcrumbOrders.hidden = !showOrders;
      if (breadcrumbProfile) breadcrumbProfile.hidden = !showProfile;
    };
    apply();
    document.addEventListener('DOMContentLoaded', apply);
    window.addEventListener('hashchange', apply);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'invalid',
    function (event) {
      var target = event.target;
      var root = target.closest && target.closest('.contact-form--underline');
      if (!root) return;
      event.preventDefault();
      target.classList.add('invalid-field');
      var field = target.closest('.contact-form__field, .contact-form__consent');
      var feedback = field && field.querySelector('.contact-form__feedback');
      if (!feedback) return;
      var data = root.dataset;
      if (target.type === 'email' && !target.validity.valueMissing) {
        feedback.textContent = data.errorEmail;
      } else if (target.type === 'checkbox') {
        feedback.textContent = data.errorConsent;
      } else if (target.type === 'tel') {
        feedback.textContent = data.errorPhone;
      } else {
        feedback.textContent = data.errorRequired;
      }
    },
    true
  );

  document.addEventListener('input', function (event) {
    var target = event.target;
    var root = target.closest && target.closest('.contact-form--underline');
    if (!root) return;
    target.classList.remove('invalid-field');
    var field = target.closest('.contact-form__field, .contact-form__consent');
    var feedback = field && field.querySelector('.contact-form__feedback');
    if (feedback) feedback.textContent = '';
  });
  } catch(e) { console.error(e); }
})();

})();
